export default __webpack_public_path__ + "static/media/Jump (11).6a9cdcec.png";